import { render, staticRenderFns } from "./coreProductInfoPhone.vue?vue&type=template&id=b48e80bc&scoped=true"
import script from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
export * from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
import style0 from "./coreProductInfoPhone.vue?vue&type=style&index=0&id=b48e80bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e80bc",
  null
  
)

export default component.exports